import React, { useEffect, useRef } from "react";
import "./About.css";
import Footer from "../components/Footer";
import {
  DiReact,
  DiJavascript1,
  DiHtml5,
  DiCss3,
  DiBootstrap,
  DiNodejs,
  DiNodejsSmall,
  DiMongodb,
} from "react-icons/di";
import { SiFirebase } from "react-icons/si";
// import { init } from "ityped";

import DevelopTitle from "../components/TitleSection";
import CodeEditor, { Browser } from "../components/CodeEditor";

export default function About() {
  // const textRef = useRef();

  // useEffect(() => {
  //   init(textRef.current, {
  //     showCursor: true,
  //     backDelay: 1500,
  //     backSpeed: 60,
  //     strings: ["awesome websites.", "cool apps."],
  //   });
  // }, []);

  return (
    <div className="about-container">
      <div className="about-wrap" id="about">
        <h2 className="dev-line">
          Web and Application Development with an extensive focus on user
          experience. <br /> Interested in doing a project?{" "}
          <a href="#contact">Lets talk!</a>
        </h2>
        <div className="tiny-heading">
          {" "}
          <small className="tiny-heading-text">Get started</small>
        </div>
        <DevelopTitle />
        <div className="dev-content-wrapper">
          <div className="dev-content">
            <div className="dev-content-left">
              <div>
                <CodeEditor />
                <Browser />
              </div>
            </div>
            <div className="dev-content-right">
              <div className="dev-content-right-item">
                <h5>Fast Loading</h5>
                <div>Improve average loading time and performance.</div>
              </div>

              <div className="dev-content-right-item">
                <h5>Good looking UI</h5>
                <div>
                  Work with best UI practices to provide great user experience.
                </div>
              </div>

              <div className="dev-content-right-item">
                <h5>Fully Functional</h5>
                <div>Make sure everything is working as intended.</div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="about-me-p1">About Me</div>
        <div className="about-me-p2">I am a Freelance Web Developer. </div>
        <div className="about-me-p3">
          <p className="about-build">
            <span id="about-build">I build </span>
            <span ref={textRef} className="about-build-items"></span>
          </p>
        </div>

        <p className="techno-title">Technologies</p>

        <p className="tech-type frontend">Frontend:</p>

        <div class="technologies frontend">
          <span>
            <DiReact />
          </span>
          <span>
            <DiJavascript1 />
          </span>
          <span>
            <DiHtml5 />
          </span>
          <span>
            <DiCss3 />
          </span>
          <span>
            <DiBootstrap />
          </span>
        </div>

        <p className="techno-items">React, Javascript, HTML, CSS, Bootstrap</p>

        <div class="technologies backend">
          <p className="tech-type backend">Backend:</p>
          <span>
            <DiNodejsSmall />
          </span>
          <span>ex</span>
          <span>
            <DiMongodb />
          </span>
          <span>
            <SiFirebase />
          </span>
        </div>


        <p className="techno-items">Node, Express, MongoDB, Firebase</p> */}
      </div>
    </div>
  );
}
